import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { StateCultureInsertService } from '../../service/stateculture-insert/stateculture-insert.service';
import { StateListService } from '../../../state/service/state-list/state-list.service';
import { CultureListService } from '../../../culture/service/culture-list/culture-list.service';

@Component({
	selector: 'app-stateculture-insert',
	templateUrl: './stateculture-insert.component.html',
	providers: [
		StateCultureInsertService,
		StateListService,
		CultureListService,
		HttpModule
	]
})

export class StateCultureInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	public states: any[] = [];
	public cultures: any[] = [];
	public unidadeMedidaCultura: string;
	stateCulture: FormGroup;
	statusCulture: boolean;

	constructor(fb: FormBuilder, private stateCultureInsertService: StateCultureInsertService, private stateListService: StateListService, private cultureListService: CultureListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.stateCulture = fb.group({
			'CulturaID': ['', Validators.compose([Validators.required])],
			'EstadoID':['', Validators.compose([Validators.required])],
			'ProdutividadeMedia': [null, Validators.compose([Validators.required])],
			'Preco': [null, Validators.compose([Validators.required])],
			'PorcentagemFertilizanteCusto': [null, Validators.compose([Validators.required])],
			'MediaFertilizante': [null, Validators.compose([Validators.required])],
			'Custo': [null, Validators.compose([Validators.required])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.getStates();
		this.getCultures();
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	selectCulture(culturaID: string) {
		if (culturaID == '') {
			this.unidadeMedidaCultura = '';
		} else {
			var cult = this.cultures.find(c => c.ID == culturaID);
			if (cult != null) {
				this.unidadeMedidaCultura = cult.UnidadeMedida;
			} else {
				this.unidadeMedidaCultura = '';
			}
		}
	}

	getStates() {
		this.stateListService.getActiveStates(this.token).subscribe(result => {
			this.states = result.Result;
		}, error => {
			console.log(error);
		});
	}

	getCultures() {
		this.cultureListService.getActiveCultures(this.token).subscribe(result => {
			this.cultures = result.Result;
		}, error => {
			console.log(error);
		});
	}


	addStateCulture(value: any) {
		console.log(value);
		this.stateCultureInsertService.insertStateCulture(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Cultura por Estado cadastrada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/culturaestado');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/culturaestado');
	}

}



// WEBPACK FOOTER //
// ./src/app/stateculture/component/stateculture-insert/stateculture-insert.component.ts